import React from 'react';

/**
 * Renderiza el bloque CalendarDialog de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function CalendarDialog({
  v
}) {
  return v.calOpen ? React.createElement(React.Fragment, null, React.createElement("div", {
    "onClick": v.closeCal,
    style: {
      "position": "absolute",
      "inset": "0",
      "zIndex": "200",
      "background": "rgba(2,6,14,0.65)",
      "backdropFilter": "blur(0.277778vh)",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center"
    }
  }, React.createElement("div", {
    "onClick": v.stopProp,
    style: {
      "width": "min(51.041667vw,94%)",
      "maxHeight": "94%",
      "overflow": "auto",
      "background": "#0b1422",
      "border": "0.092593vh solid rgba(184,193,206,0.14)",
      "borderRadius": "1.481481vh",
      "boxShadow": "0 2.777778vh 7.407407vh rgba(0,0,0,0.6)",
      "display": "grid",
      "gridTemplateColumns": "11.458333vw minmax(0,1fr)"
    }
  }, v.text("\n    "), React.createElement("aside", {
    style: {
      "padding": "1.851852vh 1.296296vh",
      "borderRight": "0.052083vw solid rgba(184,193,206,0.1)",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "background": "rgba(255,255,255,0.015)"
    }
  }, React.createElement("span", {
    style: {
      "font": "700 0.925926vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.1em",
      "color": "#8793a6",
      "padding": "0 0.740741vh 0.740741vh"
    }
  }, v.text("ATAJOS")), (v.calPre || []).map((p, index172) => React.createElement(React.Fragment, {
    key: index172
  }, React.createElement("button", {
    "onClick": p.onClick,
    style: {
      "textAlign": "left",
      "border": "0.092593vh solid " + p.bd,
      "background": p.bg,
      "color": p.c,
      "borderRadius": "0.740741vh",
      "padding": "0.740741vh 0.925926vh",
      "cursor": "pointer",
      "font": "500 1.203704vh 'IBM Plex Sans',sans-serif"
    },
    className: "scapp-full-hover"
  }, v.text(p.l)))), v.text("\n      "), React.createElement("div", {
    style: {
      "marginTop": "auto",
      "paddingTop": "1.296296vh",
      "borderTop": "0.092593vh solid rgba(184,193,206,0.1)",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "700 0.925926vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.1em",
      "color": "#8793a6",
      "padding": "0 0.185185vh"
    }
  }, v.text("ÚLTIMOS N DÍAS")), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.555556vh",
      "alignItems": "center"
    }
  }, React.createElement("input", {
    "type": "number",
    "min": "1",
    "value": v.calNDays,
    "onChange": v.calNdIn,
    style: {
      "width": "3.645833vw",
      "height": "3.148148vh",
      "boxSizing": "border-box",
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "color": "#e4e9f0",
      "padding": "0 0.740741vh",
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "textAlign": "center",
      "outline": "none"
    }
  }, null), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text("días")), React.createElement("button", {
    "onClick": v.calNdGo,
    style: {
      "marginLeft": "auto",
      "height": "3.148148vh",
      "border": "0",
      "background": "oklch(0.62 0.18 42 / 0.25)",
      "color": "#f3e2d6",
      "borderRadius": "0.740741vh",
      "padding": "0 1.111111vh",
      "cursor": "pointer",
      "font": "600 1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Aplicar"))), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text("hasta " + v.calNdEnd))), v.text("\n    ")), v.text("\n    "), React.createElement("div", {
    style: {
      "padding": "1.851852vh 2.037037vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.481481vh",
      "minWidth": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "flex-start",
      "gap": "1.481481vh"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "flex": "1"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.851852vh",
      "fontWeight": "700"
    }
  }, v.text("Rango de datos")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text("Puntos celestes = días con datos"))), React.createElement("button", {
    "onClick": v.closeCal,
    style: {
      "width": "1.770833vw",
      "height": "3.148148vh",
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "fontSize": "2.037037vh",
      "cursor": "pointer",
      "borderRadius": "0.740741vh"
    },
    className: "scapp-full-hover"
  }, v.text("×"))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1fr) auto minmax(0,1fr) 5.729167vw",
      "gap": "0.925926vh",
      "alignItems": "stretch"
    }
  }, React.createElement("div", {
    style: {
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "padding": "0.740741vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "letterSpacing": "0.08em",
      "color": "#8793a6"
    }
  }, v.text("DESDE")), React.createElement("span", {
    style: {
      "font": "600 1.388889vh 'IBM Plex Mono',monospace"
    }
  }, v.text(v.calFrom))), React.createElement("span", {
    style: {
      "alignSelf": "center",
      "color": "#5a667a"
    }
  }, v.text("→")), React.createElement("div", {
    style: {
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "padding": "0.740741vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "letterSpacing": "0.08em",
      "color": "#8793a6"
    }
  }, v.text("HASTA")), React.createElement("span", {
    style: {
      "font": "600 1.388889vh 'IBM Plex Mono',monospace",
      "color": v.calToC
    }
  }, v.text(v.calTo))), React.createElement("div", {
    style: {
      "borderRadius": "0.740741vh",
      "background": "oklch(0.62 0.18 42 / 0.15)",
      "border": "0.092593vh solid oklch(0.62 0.18 42 / 0.5)",
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "center",
      "justifyContent": "center"
    }
  }, React.createElement("span", {
    style: {
      "font": "700 2.222222vh 'IBM Plex Mono',monospace",
      "lineHeight": "1"
    }
  }, v.text(v.calCnt)), React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "letterSpacing": "0.08em",
      "color": "#f3e2d6"
    }
  }, v.text("DÍAS")))), v.text("\n      \n      \n      "), React.createElement("div", {
    "onMouseLeave": v.calLeave,
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(2,minmax(0,1fr))",
      "gap": "2.222222vh"
    }
  }, (v.calMonths || []).map((m, index173) => React.createElement(React.Fragment, {
    key: index173
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "minWidth": "0"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "padding": "0 0 0.37037vh"
    }
  }, m.isPrev ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.calPrev,
    style: {
      "width": "1.770833vw",
      "height": "3.148148vh",
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "color": "#e4e9f0",
      "cursor": "pointer",
      "fontSize": "1.481481vh"
    }
  }, v.text("‹"))) : null, React.createElement("div", {
    style: {
      "flex": "1",
      "position": "relative",
      "display": "flex",
      "justifyContent": "center"
    }
  }, React.createElement("button", {
    "onClick": m.pick,
    "title": "Cambiar mes y año",
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "border": "0.092593vh solid " + m.pbd,
      "background": m.pbg,
      "color": "#e4e9f0",
      "borderRadius": "0.740741vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "700 1.388889vh 'IBM Plex Sans',sans-serif"
    },
    className: "scapp-full-hover"
  }, v.text(m.title), React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6"
    }
  }, v.text("▾"))), v.text("\n          "), m.pOpen ? React.createElement(React.Fragment, null, React.createElement("div", {
    "onClick": v.stopProp,
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.555556vh)",
      "left": "50%",
      "transform": "translateX(-50%)",
      "zIndex": "10",
      "width": "13.541667vw",
      "background": "#101c2e",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "borderRadius": "1.111111vh",
      "boxShadow": "0 1.481481vh 3.703704vh rgba(0,0,0,0.55)",
      "padding": "1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between"
    }
  }, React.createElement("button", {
    "onClick": m.yPrev,
    style: {
      "width": "1.5625vw",
      "height": "2.777778vh",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "background": "transparent",
      "color": "#e4e9f0",
      "borderRadius": "0.740741vh",
      "cursor": "pointer"
    }
  }, v.text("‹")), React.createElement("span", {
    style: {
      "font": "700 1.481481vh 'IBM Plex Mono',monospace"
    }
  }, v.text(m.pYear)), React.createElement("button", {
    "onClick": m.yNext,
    style: {
      "width": "1.5625vw",
      "height": "2.777778vh",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "background": "transparent",
      "color": "#e4e9f0",
      "borderRadius": "0.740741vh",
      "cursor": "pointer"
    }
  }, v.text("›"))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(3,minmax(0,1fr))",
      "gap": "0.555556vh"
    }
  }, (m.pMonths || []).map((x, index174) => React.createElement(React.Fragment, {
    key: index174
  }, React.createElement("button", {
    "onClick": x.go,
    style: {
      "height": "3.148148vh",
      "borderRadius": "0.740741vh",
      "border": "0.092593vh solid " + x.bd,
      "background": x.bg,
      "color": x.c,
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif",
      "position": "relative"
    },
    className: "scapp-full-hover"
  }, v.text(x.l), React.createElement("span", {
    style: {
      "position": "absolute",
      "bottom": "0.37037vh",
      "left": "50%",
      "width": "0.208333vw",
      "height": "0.37037vh",
      "marginLeft": "-0.104167vw",
      "borderRadius": "50%",
      "background": x.dot
    }
  }, null))))), v.text("\n          "))) : null), m.isCur ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.calNext,
    style: {
      "width": "1.770833vw",
      "height": "3.148148vh",
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "color": "#e4e9f0",
      "cursor": "pointer",
      "fontSize": "1.481481vh"
    }
  }, v.text("›"))) : null), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(7,minmax(0,1fr))",
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#5a667a",
      "textAlign": "center"
    }
  }, React.createElement("span", {}, v.text("L")), React.createElement("span", {}, v.text("M")), React.createElement("span", {}, v.text("M")), React.createElement("span", {}, v.text("J")), React.createElement("span", {}, v.text("V")), React.createElement("span", {}, v.text("S")), React.createElement("span", {}, v.text("D"))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(7,minmax(0,1fr))",
      "rowGap": "0.37037vh"
    }
  }, (m.cells || []).map((c, index175) => React.createElement(React.Fragment, {
    key: index175
  }, React.createElement("div", {
    "onClick": c.click,
    "onMouseEnter": c.enter,
    style: {
      "height": "3.333333vh",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "background": c.band,
      "borderRadius": c.bl + " " + c.br + " " + c.br + " " + c.bl,
      "opacity": c.vis,
      "cursor": "pointer"
    }
  }, React.createElement("span", {
    style: {
      "position": "relative",
      "width": "1.770833vw",
      "height": "3.148148vh",
      "borderRadius": "50%",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "background": c.cbg,
      "boxShadow": c.ring,
      "color": c.c,
      "font": c.fw + " 1.296296vh 'IBM Plex Sans',sans-serif"
    },
    className: "scapp-full-hover"
  }, v.text(c.n), React.createElement("span", {
    style: {
      "position": "absolute",
      "bottom": "0.37037vh",
      "left": "50%",
      "width": "0.208333vw",
      "height": "0.37037vh",
      "marginLeft": "-0.104167vw",
      "borderRadius": "50%",
      "background": c.dot
    }
  }, null)))))))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "flex-end",
      "gap": "0.925926vh",
      "paddingTop": "0.37037vh",
      "borderTop": "0.092593vh solid rgba(184,193,206,0.08)"
    }
  }, React.createElement("button", {
    "onClick": v.closeCal,
    style: {
      "border": "0.092593vh solid rgba(184,193,206,0.2)",
      "background": "transparent",
      "color": "#b8c1ce",
      "borderRadius": "0.740741vh",
      "padding": "0.833333vh 1.666667vh",
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif",
      "marginTop": "0.925926vh"
    }
  }, v.text("Cancelar")), React.createElement("button", {
    "onClick": v.calApply,
    style: {
      "border": "0",
      "background": "oklch(0.62 0.18 42)",
      "color": "#fff",
      "borderRadius": "0.740741vh",
      "padding": "0.833333vh 2.037037vh",
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif",
      "opacity": v.calApplyOp,
      "marginTop": "0.925926vh"
    }
  }, v.text("Aplicar rango"))), v.text("\n    ")), v.text("\n  ")))) : null;
}
